import { render } from "./FinishStep.vue?vue&type=template&id=d5189130"
import script from "./FinishStep.vue?vue&type=script&lang=js"
export * from "./FinishStep.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__